import {  useForm } from "react-hook-form";
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Grid, TextField, } from "@material-ui/core";
import { addAssets } from '../../../store/assets/actions';
import { getAssets } from '../../../store/assets/selectors';
import { basic, validationMessages, requiredOnly, requiredOnlyMessage } from '../../../config/validations';

export default function CreateFolder (props) {
    
    const { onClose, onCompletion, parent } = props;
    const dispatch = useDispatch();
    const { register, handleSubmit, formState: { errors }, reset, setError } = useForm();
    const [loading, setLoading] = useState(false);
    const assets = useSelector(getAssets);
    
    const onCreate = async ({ name }) => {   
        let formData = new FormData()
        let url = window.location.pathname
		let blueprintId = url.split('/')[3];
        formData.append('blueprintId', blueprintId);
        formData.append('assetFile', name);
        formData.append('type', 'folder');
        formData.append('parent', parent);


        setLoading(true);
        let result = await dispatch(addAssets(formData))
        setLoading(false);
        if(result.status){
            onCompletion('Directory', 'add', result.status);
            reset({name:""});
        } else {
            if (result?.code === process.env.REACT_APP_FORM_ERROR_CODE) {
                result?.errors?.forEach(error => {
                    setError(error.name, {message: error.message});
                });
            }
        }
    }

    const messages = {
        ...validationMessages,
        validate: 'Directory name already exists'
    }


    return (
        <Grid container direction={"row"} spacing={3}>
            
            <Grid item xs={12}>                
                <TextField
                    id="name"
                    type={"text"}
                    fullWidth
                    label={"Name"}
                    placeholder={""}
                    variant="outlined"
                    name="name"
                    error={errors?.name ? true : false}
                    helperText={errors?.name ? errors?.name?.message ? errors.name.message : messages[errors?.name?.type] : ''}
                    inputRef={register({ ...basic })}
                />
            </Grid>

            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginBottom: 20 }}>
                <Button onClick={onClose} color="primary" variant="outlined" style={{ marginLeft: 10 }}>
                    Cancel
                </Button>
                <Button disabled={loading} onClick={handleSubmit(onCreate)} color="primary" variant="contained" style={{ marginLeft: 10 }}>
                   {loading ? 'Creating..' : 'Create'} 
                </Button>
            </Grid>
        </Grid>
    );

}